module.exports = __webpack_public_path__ + "static/media/ellipsis-white.ffaef633.svg";